<template>
  <div>
    <!-- ── Post action menu ───────────────────────────────── -->
    <modal
      class="menu"
      :name="'menu-modal' + normalizedPostId"
      width="100%"
      height="auto"
    >
      <ListItem
        v-if="!post.reflectionId"
        border="1px solid #31b9be"
        @click.native="navigateBasedOnRole()"
      >{{ $t("general.post.edit") }}</ListItem>
      <ListItem
        border="1px solid #31b9be"
        last="true"
        @click.native="onDeleteClick"
      >{{ $t("general.post.delete") }}</ListItem>
    </modal>

    <!-- ── Delete confirmation (post has an image) ────────── -->
    <modal
      :name="'delete-image-modal' + normalizedPostId"
      width="92%"
      height="auto"
      :max-width="480"
      :clickToClose="false"
      :adaptive="true"
      :scrollable="false"
    >
      <div class="confirm-modal">
        <p class="confirm-modal__question">
          {{ $t("general.post.confirm-image-deletion") }}
        </p>

        <div class="confirm-modal__actions">
          <button class="btn btn--cancel" @click="closeDeleteImageModal">
            {{ $t("general.post.action-cancel") }}
          </button>
          <button class="btn btn--keep" @click="confirmDeletePostOnly">
            {{ $t("general.post.delete-post-only") }}
          </button>
          <button class="btn btn--delete" @click="confirmDeletePostAndImage">
            {{ $t("general.post.delete-post-and-image") }}
          </button>
        </div>

        <p class="confirm-modal__note">
          {{ $t("general.post.delete-post-diary-note") }}
        </p>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: "EditPostModal",
  props: {
    post: { required: true }
  },
  computed: {
    normalizedPostId() {
      return this.post.postId || this.post.id;
    }
  },
  methods: {
    onDeleteClick() {
      if (!this.normalizedPostId) return;

      this.$modal.hide("menu-modal" + this.normalizedPostId);

      if (this.post.uploadId) {
        this.$modal.show("delete-image-modal" + this.normalizedPostId);
        return;
      }

      // No image: emit directly — the parent (Post.vue) owns the final confirm
      this.$emit("delete-post", this.normalizedPostId, false);
    },
    closeDeleteImageModal() {
      this.$modal.hide("delete-image-modal" + this.normalizedPostId);
    },
    confirmDeletePostOnly() {
      this.$modal.hide("delete-image-modal" + this.normalizedPostId);
      this.$emit("delete-post", this.normalizedPostId, false);
    },
    confirmDeletePostAndImage() {
      this.$modal.hide("delete-image-modal" + this.normalizedPostId);
      this.$emit("delete-post", this.normalizedPostId, true);
    },
    navigateBasedOnRole() {
      if (!this.post.reflectionId && this.normalizedPostId) {
        window.location.href = `/create/post?postId=${this.normalizedPostId}`;
      }
    }
  }
};
</script>

<style scoped lang="scss">
/* ── Confirm dialog ──────────────────────────────────────────── */
.confirm-modal {
  padding: 28px 24px 24px;
  text-align: center;
}

.confirm-modal__question {
  color: #00a9b3;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.45;
  margin: 0 0 24px;
}

/* Button row: stacks vertically on very small screens */
.confirm-modal__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.confirm-modal__note {
  margin: 14px 0 0;
  color: #7b7b7b;
  font-size: 12px;
  line-height: 1.45;
}

/* ── Shared button base ──────────────────────────────────────── */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  padding: 10px 18px;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 2px solid transparent;
  transition: opacity 0.15s ease;
  white-space: nowrap;

  &:hover,
  &:focus-visible {
    opacity: 0.82;
    outline: none;
  }
}

/* Cancel — neutral */
.btn--cancel {
  background: #fff;
  color: #8e8e8e;
  border-color: #d0d0d0;
}

/* Keep post, discard image */
.btn--keep {
  background: #fff;
  color: #31b9be;
  border-color: #31b9be;
}

/* Delete everything */
.btn--delete {
  background: #fff;
  color: #e05484;
  border-color: #e05484;
}

@media (max-width: 380px) {
  .confirm-modal {
    padding: 20px 16px 18px;
  }

  .btn {
    width: 100%;
  }
}
</style>